// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d3e1cdfa] .el-dialog ::v-deep .el-dialog__header{padding:20px 20px 10px!important;border-bottom:1px solid #dcdcdc}[data-v-d3e1cdfa] .el-dialog ::v-deep .el-dialog__body{padding:10px 36px!important}", ""]);
// Exports
module.exports = exports;
